// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* head bar text color */
@font-face {
  color: #000;
  font-family: Roboto-Black;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Bold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-SemiBold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Light;
  src: url("/assets/fonts/Roboto-Light.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Medium;
  src: url("/assets/fonts/Roboto-Medium.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Regular;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Thin;
  src: url("/assets/fonts/Roboto-Thin.ttf") format("truetype");
}
:host {
  display: flex;
  flex-direction: row;
}
:host .cs-left-panel {
  width: 250px;
  background: #fff;
  border-right: 1px solid #dfe3eb;
  position: fixed;
  overflow-y: auto;
  z-index: 1;
}
:host .cs-left-panel .cs-left-title {
  padding: 0.45rem 1rem;
  background-color: var(--cs-secondary-color);
  color: #fff;
  flex: 1;
}
:host .cs-left-panel .cs-left-title h6 {
  margin-bottom: 0;
  line-height: 25px;
}
:host .cs-left-panel .cs-left-title h6 span {
  font-size: 0.8rem;
}
:host .cs-left-panel .cs-left-title cs-icon {
  width: 16px;
  height: 16px;
  margin-right: 0.6rem;
}
:host .cs-left-panel .left-panel-bottom {
  bottom: 0;
  position: absolute;
  width: 100%;
  display: flex;
}
:host .cs-content {
  width: calc(100% - 250px);
  margin-left: 250px;
  padding: 1rem;
}
:host.menu-collapsed .cs-left-panel {
  width: 50px;
  overflow: initial;
}
:host.menu-collapsed .cs-left-panel .cs-left-title {
  padding: 0;
}
:host.menu-collapsed .cs-left-panel .cs-left-title h6 {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: initial;
}
:host.menu-collapsed .cs-left-panel .cs-left-title span {
  display: none;
}
:host.menu-collapsed .cs-left-panel .cs-left-title cs-icon {
  margin-right: 0;
}
:host.menu-collapsed .cs-left-panel .left-panel-bottom {
  display: inherit;
}
:host.menu-collapsed .cs-content {
  width: calc(100% - 50px);
  margin-left: 50px;
}
:host .collapse-side-menu {
  padding: 0.45rem 1rem;
  right: 0;
  background: var(--cs-primary-color);
  text-align: right;
  outline: 0;
  border: 0;
  width: 100%;
  flex: 0 1;
}
:host .collapse-side-menu cs-icon {
  width: 16px;
  height: 16px;
  color: #fff;
}
:host.menu-collapsed .collapse-side-menu {
  transform: rotate(180deg);
  height: 50px;
}
:host ul.tree-menu {
  list-style: none;
  padding: 0;
  margin-bottom: 0;
  height: calc(100% - 41px);
}
:host ul.tree-menu > li {
  border-bottom: 1px solid #ddd;
}
:host ul.tree-menu > li .leaf-text {
  color: #494949;
  display: block;
  padding: 0.45rem 1rem 0.45rem 1.8rem;
  font-size: 14px;
  width: 100%;
  text-decoration: none;
  background: #f5f8fa;
  margin-bottom: 2px;
  position: relative;
  z-index: 11;
}
:host ul.tree-menu > li .leaf-text:hover {
  color: var(--cs-primary-color);
  background: #fff;
}
:host ul.tree-menu > li .leaf-text:hover .cs-primary-text {
  color: var(--cs-primary-color);
}
:host ul.tree-menu > li .node {
  outline: 0;
  background-color: transparent;
  border: 0;
  display: block;
  width: 100%;
  padding: 0;
  text-decoration: none;
  color: inherit;
}
:host ul.tree-menu > li .node ul {
  list-style: none;
  padding: 0;
}
:host ul.tree-menu > li .node ul.modules {
  max-height: 0;
  overflow: hidden;
  transition: 400ms ease all;
}
:host ul.tree-menu > li .node ul.modules li a {
  text-align: left;
}
:host ul.tree-menu > li .node ul.modules li a .icon-label {
  width: 14px;
  height: 14px;
  margin-right: 0.6rem;
  line-height: 0.5px;
}
:host ul.tree-menu > li .node ul.modules li a.sub-node-active {
  background-color: #fff;
  color: var(--cs-primary-color);
}
:host ul.tree-menu > li .node ul.modules li a.sub-node-active .cs-primary-text {
  color: var(--cs-primary-color);
}
:host ul.tree-menu > li .node.expand-node .node-header .state-arrow {
  transform: rotate(0deg);
}
:host ul.tree-menu > li .node.expand-node .modules {
  max-height: 600px;
  transition: 400ms ease all;
}
:host ul.tree-menu > li .node.node-active .node-header {
  background: #eaeef2;
}
:host ul.tree-menu > li .node .node-header {
  padding: 0.8rem 1rem 0.8rem 1.8rem;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  margin: 0;
}
:host ul.tree-menu > li .node .node-header .icon-label {
  width: 14px;
  height: 14px;
  margin-right: 0.6rem;
  line-height: 0.5px;
}
:host ul.tree-menu > li .node .node-header .state-arrow {
  transform: rotate(-90deg);
  transition: all 175ms cubic-bezier(0.4, 0, 0.2, 1);
  margin-left: auto;
  width: 15px;
  height: 15px;
}
:host ul.tree-menu > li .no-children-node {
  font-family: Roboto-Regular;
  background: #eaeef2;
  color: #4b5b70;
  font-size: 15px;
  margin-bottom: 0;
  position: inherit;
  z-index: 0;
}
:host ul.tree-menu > li .no-children-node .icon-label {
  width: 14px;
  height: 22px;
  margin-right: 0.6rem;
}
:host ul.tree-menu > li .no-children-node.no-children-node-active {
  background: #fff;
  color: var(--cs-primary-color);
}
:host ul.tree-menu > li .no-children-node.no-children-node-active .icon-label {
  color: var(--cs-primary-color);
}
:host ul.tree-menu > li .no-children-node.leaf-text:hover {
  background: #fff;
  color: var(--cs-primary-color);
}
:host.menu-collapsed ul.tree-menu > li .leaf-text {
  margin: 0;
}
:host.menu-collapsed ul.tree-menu > li .node {
  position: relative;
}
:host.menu-collapsed ul.tree-menu > li .node .node-header {
  padding: 0.5rem;
  width: 100%;
  height: 40px;
  justify-content: center;
  align-items: center;
}
:host.menu-collapsed ul.tree-menu > li .node .node-header span {
  display: none;
}
:host.menu-collapsed ul.tree-menu > li .node .node-header .icon-label {
  margin: 0;
  line-height: 14px;
}
:host.menu-collapsed ul.tree-menu > li .node .node-header .state-arrow {
  display: none;
}
:host.menu-collapsed ul.tree-menu > li .node:hover .modules {
  display: block;
  top: 0;
  left: 100%;
  height: auto;
  background: white;
  box-shadow: 0 1px 5px 0 rgba(45, 62, 80, 0.12);
  overflow: inherit;
}
:host.menu-collapsed ul.tree-menu > li .node:hover .modules li a {
  padding: 0.45rem 1rem;
  white-space: nowrap;
}
:host.menu-collapsed ul.tree-menu > li .modules {
  display: none;
  position: absolute;
}
:host.menu-collapsed ul.tree-menu > li .modules.open-sub-node {
  position: initial;
  display: block;
}
:host.menu-collapsed ul.tree-menu > li .modules.open-sub-node li a {
  padding-left: 1rem;
}
:host.menu-collapsed ul.tree-menu > li .modules.open-sub-node .hidden-collapsed {
  display: none;
}
:host.menu-collapsed ul.tree-menu > li .no-children-node {
  padding: 0.5rem;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
:host.menu-collapsed ul.tree-menu > li .no-children-node span {
  display: none;
}
:host.menu-collapsed ul.tree-menu > li .no-children-node .icon-label {
  margin: 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
